import { Module } from 'vuex';

import { LearningGroupCourse, RootState } from 'frontend/types';

interface LearningPathCoursesState {
  items: LearningGroupCourse[];
}

const learningPathCourses: Module<LearningPathCoursesState, RootState> = {
  namespaced: true,
  state: () => ({
    items: [],
  }),
  getters: {
    learningPathCourses: state => state.items,
  },
  mutations: {
    setValue(state: LearningPathCoursesState, value: LearningGroupCourse[]): void {
      state.items = value;
    },
  },
  actions: {},
};

export default learningPathCourses;
